import React, { useEffect, useState } from 'react';
import Image from '../Image';
import CurrentArticle from './CurrentArticle';
import { Link } from 'react-router-dom';

function Current(props) {

    const [currentArticles, setCurrentArticles] = useState([]);

    useEffect(() => {
      if (!props?.issue?.id) return; // Safeguard: wait for issue.id to be available

      fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=getArticlesByIssueId&issue_id=${props.issue.id}`)
          .then(res => res.json())
          .then(data => {
              if (data.success) {
                  const publishedArticles = data.articles
                      .filter(article => article.publish === 1)
                      .slice(0, 3);

                  setCurrentArticles(publishedArticles);
              }
          })
          .catch(err => console.error('Failed to fetch issues:', err));
    }, [props?.issue?.id]);

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options).replace(/ /g, '-');
    };

    return (
      <>
        <div className="curr_section">
            <div className="curr_wrapper">
                <div className="section_hr">

                </div>
                <p className='section_title'>Current Issue</p>

                <div className='curr_content_wrapper'>
                  <div className='curr_content_image_wrapper'>
                    <Image src={props?.issue?.image} alt="Annals of Nursing - vol2-issue2" class="current_issue_image"/>
                  </div>
                  <div className='curr_content_text_wrapper'>
                      <h3 className='curr_content_text_title'>
                         <Link to={`/articles?issue=${props?.issue?.id}`} className='curr_content_text_title_link'>Annals of Nursing <div className='curr_content_text_title_link_subtitle'> - {props?.issue?.title}</div></Link>
                      </h3>

                      <p className='curr_content_text_date'>
                        <span className="fa-regular fa-calendar"></span>&nbsp;{formatDate(props?.issue?.date)}
                      </p>

                      <div className='curr_content_text_articles'>

                        {currentArticles.map((article, index) => (
                            <CurrentArticle key={index} id={article.id} title={article.title} article_type={article.type} authors={article.authors} />
                        ))}                        

                        <div className='ann_link_wrapper curr_ann_align'>
                          <Link to={`/articles?issue=${props?.issue?.id}`} className='ann_link'>More articles from this issue&nbsp;&nbsp;<span className="fa-solid fa-angle-right"></span></Link>
                        </div>

                      </div>

                  </div>
                </div>

            </div>
        </div>
      </>
    );
}

export default Current;
